// extracted by extract-css-chunks-webpack-plugin
module.exports = {"categoryIcon":"J2mCHL","noMargin":"_3cQntd"};